import React from 'react';
import { RefreshCw } from 'lucide-react';

/**
 * Visual indicator for the pull-to-refresh gesture. Sits at the top of the
 * scrollable area and grows from 0 → `threshold` as the user pulls.
 *
 * The arrow rotates with the drag and snaps into the spinner once a refresh
 * is in flight.
 */
export default function PullToRefreshIndicator({ pullDistance, refreshing, threshold = 80 }) {
  const visible = pullDistance > 4 || refreshing;
  if (!visible) return null;

  const ratio = Math.min(pullDistance / threshold, 1);
  const rotate = ratio * 180;
  const opacity = Math.min(0.4 + ratio * 0.6, 1);

  return (
    <div
      className="md:hidden pointer-events-none absolute left-0 right-0 top-0 flex items-start justify-center z-20"
      style={{ height: `${refreshing ? threshold : pullDistance}px` }}
    >
      <div
        className="w-9 h-9 rounded-full bg-card border border-border shadow-md flex items-center justify-center mt-3"
        style={{ opacity }}
      >
        <RefreshCw
          className={`w-4 h-4 text-amber-500 ${refreshing ? 'animate-spin' : ''}`}
          style={!refreshing ? { transform: `rotate(${rotate}deg)`, transition: 'transform 0.1s' } : undefined}
        />
      </div>
    </div>
  );
}
